import React from "react";

const EditIcon = () => {
  return (
    <svg
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.91601 6.41675H5.99935C5.51312 6.41675 5.0468 6.6099 4.70299 6.95372C4.35917 7.29754 4.16602 7.76385 4.16602 8.25008V16.5001C4.16602 16.9863 4.35917 17.4526 4.70299 17.7964C5.0468 18.1403 5.51312 18.3334 5.99935 18.3334H14.2493C14.7356 18.3334 15.2019 18.1403 15.5457 17.7964C15.8895 17.4526 16.0827 16.9863 16.0827 16.5001V15.5834"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.1667 4.58343L17.9167 7.33343M19.1862 6.03635C19.5473 5.67532 19.7501 5.18567 19.7501 4.6751C19.7501 4.16453 19.5473 3.67487 19.1862 3.31385C18.8252 2.95282 18.3356 2.75 17.825 2.75C17.3144 2.75 16.8248 2.95282 16.4637 3.31385L8.75 11.0001V13.7501H11.5L19.1862 6.03635Z"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default EditIcon;
